import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { useGet } from '@/hooks/useGet';
import { useGetPaginated } from '@/hooks/useGetPaginated';
import { Report } from '@/models/Report';
import { ReportProcess } from '@/models/ReportProcess';
import ReportCard from '@/pages/Data/Reports/ReportCard';
import { ApplicationState } from '@/store';
import { generateAsyncReportClear } from '@/store/report/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

const Reports: React.FC = () => {

    const [refreshInterval, setRefreshInterval] = useState<number>(10000);

    const { organizationId, applicationId } = useSelector((state: ApplicationState) => {
        return {
            applicationId: state.identity.data.user.applicationId,
            organizationId: state.identity.data.user.orgId,
        };
    });
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(generateAsyncReportClear());
        };
    }, []);

    const getKey = (index: number) => {
        return Constants.TRACKING_REPORTS_PAGINATION.replace('%a', String(applicationId)).replace('%o', String(organizationId));
    };

    const { data } = useGetPaginated<Report>(getKey);

    const { data: reportProcess, loading } = useGet<ReportProcess[]>(`${Constants.TRACKING_REPORTS}/pending`, { refreshInterval: refreshInterval });

    const findPendingProcess = (reportId: number): boolean => {
        let result = false;
        if (reportProcess) {
            result = reportProcess.some((it) => it.report && it.report.id === reportId);
        }

        return result;
    };

    return (
        <div className="report-container">
            {loading && <Loader />}
            {!loading &&
                data &&
                data
                    .filter((report) => report.applicationId)
                    .map((report) => {
                        const hasPendingProcess = findPendingProcess(report.id);
                        return <ReportCard hasPendingProcess={hasPendingProcess} key={report.id} report={report} setRefreshInterval={setRefreshInterval} />;
                    })}
        </div>
    );
};

export default Reports;
